import React from 'react';
import { HashLink } from 'react-router-hash-link';

const CallToAction = () => {
    return (
        <section className="bg-gray-50 py-16">
            <div className="container mx-auto px-4 w-[70%]">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                    <div className="md:w-2/3">
                        <h2 className="text-4xl font-bold mb-4 text-gray-800">
                            Ready to build your vision?
                        </h2>
                        <p className="text-gray-600 text-lg mb-8 md:mb-0">
                            At Dari Investment Limited, we are committed to turning
                            your construction dreams into reality. Contact us today to
                            discuss how we can bring your projects to life with our
                            expert solutions
                        </p>
                    </div>
                    <div className="md:w-1/3 text-center md:text-right">
                            <HashLink
                               smooth to="/#contact"
                                className="inline-block bg-purple-600 text-white px-8 py-4 rounded-full text-xl font-semibold hover:bg-purple-700 transition-colors duration-300"
                            >
                                Contact Us
                            </HashLink>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CallToAction;